import { LogoBayutKsa, LogoBayutKsaArabic } from '../../../../components/svg';
import React from 'react';

export const Logo = ({ rtl }) => {
  return rtl ? <LogoBayutKsaArabic width={220} height="auto" /> : <LogoBayutKsa width={190} height="auto" />;
};
